export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-narrow.c0e83054f819f9aa37569a32c30d0c21.webp";